import api from './api';

// Public -- no auth needed
export const getGallery = async () => {
  const response = await api.get('/marketing-gallery');
  return response.data;
};

// Admin-only
export const uploadGalleryPhoto = async (file, caption) => {
  const formData = new FormData();
  formData.append('image', file);
  if (caption) formData.append('caption', caption);
  const response = await api.post('/marketing-gallery/admin', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteGalleryPhoto = async (id) => {
  const response = await api.delete(`/marketing-gallery/admin/${id}`);
  return response.data;
};
